import Swal from "sweetalert2";

const swal = Swal.mixin({
  confirmButtonText: "Aceptar",
  cancelButtonText: "Cancelar",
  customClass: {
    confirmButton: "btn btn-sm btn-primary",
    cancelButton: "btn btn-sm btn-secondary ml-2",
  },
  buttonsStyling: false,
  heightAuto: false,
});

export const confirm = swal.mixin({
  showCancelButton: true,
  icon: "question",
});

export const toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 10000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
  showCloseButton: true,
  customClass: {
    title: "font-weight-normal mr-2",
  },
});

export default swal;
